import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const CustomPage = lazy(() => import('../pages/custom-page/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/page/:slug',
    element: <CustomPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
